export default __webpack_public_path__ + "static/media/alur.ac6697d3.svg";